import React from 'react';
import { useTranslation } from 'react-i18next';
import { Message } from '@weezevent/nacre';

export default function QuotasExceeded() {
    const { t } = useTranslation();
    return <Message title={t('attendees.invitations.premium_quota_exceeded')} type="danger" />;
}
